export const WAITING_LIST_BLOCKED_CODE = "ENROLLMENT_WAITING_LIST_BLOCKED";

export const WAITING_LIST_MANAGER_ROLES = ["admin", "coordinator", "secretary"];

export const WAITING_LIST_STATUSES = {
  WAITING: "waiting",
  ACTIVE: "active",
  INACTIVE: "inactive",
  DECLINED: "declined",
};

export const WAITING_LIST_STATUS_LABELS = {
  waiting: "Na lista de espera",
  active: "Liberado",
  inactive: "Removido da lista de espera",
  declined: "Recusou a lista de espera",
};

export const WAITING_LIST_MANAGER_TRANSITIONS = {
  [WAITING_LIST_STATUSES.WAITING]: [
    WAITING_LIST_STATUSES.ACTIVE,
    WAITING_LIST_STATUSES.INACTIVE,
  ],
  [WAITING_LIST_STATUSES.INACTIVE]: [WAITING_LIST_STATUSES.ACTIVE],
};

export function canChangeWaitingListStatus(currentStatus, newStatus) {
  return (WAITING_LIST_MANAGER_TRANSITIONS[currentStatus] || []).includes(
    newStatus
  );
}

export function hasWaitingListActions(status) {
  return (WAITING_LIST_MANAGER_TRANSITIONS[status] || []).length > 0;
}

const PITITIM_GRADE = "B1_8";

const CYCLE_SEGMENTS = {
  pititim: "Pititim",
  infantil: "Infantil",
  fundamental: "Fundamental",
  ensinoMedio: "Ensino Médio",
};

export function cycleSegment({ grade, cycle_group }) {
  const key = grade === PITITIM_GRADE ? "pititim" : cycle_group;

  return { key, label: CYCLE_SEGMENTS[key] || cycle_group };
}

export function waitingListStatusLabel(status) {
  return WAITING_LIST_STATUS_LABELS[status] || "Ciclo indisponível";
}

export const WAITING_LIST_POPUP_OPTIONS = {
  customClass: {
    popup: "waiting-list-popup",
  },
  didOpen: (popup) => {
    const title = popup.querySelector(".swal2-title");
    const content = popup.querySelector(".swal2-html-container");
    const actions = popup.querySelector(".swal2-actions");

    popup.style.textAlign = "center";

    if (title) {
      title.style.color = "#b23066";
    }

    if (content) {
      content.style.setProperty("color", "#000", "important");
      content.style.textAlign = "center";
      content.style.fontSize = "1.125em";
      content.parentElement.style.fontSize = "inherit";
    }

    if (actions) {
      actions.style.display = "flex";
      actions.style.justifyContent = "center";
      actions.style.gap = "20px";

      actions.querySelectorAll("button").forEach((button) => {
        button.style.flex = "0 0 calc(50% - 10px)";
      });
    }
  },
};
